import { Outlet, useLocation } from 'react-router'
import { motion } from 'framer-motion'
import useHelmet from '../../utilities/hooks/helmet/useHelmet'
import Footer from 'components/footer'
import { footerItems } from 'utilities/helper/footerItems'
import { useDispatch, useSelector } from 'react-redux'
import { toggleLogoutModal, toggleSupportModal } from 'store/redux/sidebar'
import { RootState } from 'store/redux'
import SupportModal from 'components/modals/supportModal'
import LogoutModal from 'components/modals/logout'
const DashboardLayout = () => {
    const { isOpenSupportModal, isOpenLogoutModal } = useSelector(
        (state: RootState) => state.sideBarControler
    )
    const dispatch = useDispatch()
    const { pathname } = useLocation()
    useHelmet('همیان')

    return (
        <div className="sm:w-full md:px-[35%]  md:bg-bg-md-screen">
            <div className=" h-full bg-main-bg">
                <div className=" min-h-screen flex flex-col relative">
                    <motion.div
                        key={pathname}
                        initial={{ opacity: 0, x: '100%' }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: '-100%' }}
                        transition={{ duration: 0.2 }}
                        className=" grow"
                    >
                        <div className="grow mb-20">
                            <Outlet />
                        </div>
                    </motion.div>
                    <Footer menus={footerItems} />
                </div>
            </div>
            <SupportModal
                show={isOpenSupportModal}
                onHide={() =>
                    dispatch(toggleSupportModal({ isOpenSupportModal: false }))
                }
            />
            <LogoutModal
                show={isOpenLogoutModal}
                onHide={() =>
                    dispatch(toggleLogoutModal({ isOpenLogoutModal: false }))
                }
            />
        </div>
    )
}

export default DashboardLayout
